import RoutesMap from "route_control/RouteControl"
import { Profile, UserList, PremiseUserList, AddPremiseUser, UpdatePremiseUser, PremiseUserDetails, ServiceProviderList, AddServiceProvider, UpdateServiceProvider, ServiceProviderDetails, StaffAttendanceList, StaffAttendanceCalendar, PremiseUserAttendanceList, PremiseUserAttendanceCalendar, ChangeRequestList, XpressAdmins, StaffManagement, PayrollSummary, PayrollSummaryDetail, RoleAndUser, ExpressAdminRolesUsers } from "pages/user"

const UsersRoute = () => {
    return [
        {
            path: RoutesMap.PROFILE.path,
            element: <Profile />
        },

        {
            path: RoutesMap.USER_LIST.path,
            element: <UserList />
        },

        {
            path: RoutesMap.PREMISE_USER_LIST.path,
            element: <PremiseUserList />
        },
        {
            path: RoutesMap.ADD_PREMISE_USER.path,
            element: <AddPremiseUser />
        },
        {
            path: RoutesMap.UPDATE_PREMISE_USER.path,
            element: <UpdatePremiseUser />
        },
        {
            path: RoutesMap.PREMISE_USER_DETAILS.path,
            element: <PremiseUserDetails />
        },

        {
            path: RoutesMap.SERVICE_PROVIDER_LIST.path,
            element: <ServiceProviderList />
        },
        {
            path: RoutesMap.ADD_SERVICE_PROVIDER.path,
            element: <AddServiceProvider />
        },
        {
            path: RoutesMap.UPDATE_SERVICE_PROVIDER.path,
            element: <UpdateServiceProvider />
        },
        {
            path: RoutesMap.SERVICE_PROVIDER_DETAILS.path,
            element: <ServiceProviderDetails />
        },

        {
            path: RoutesMap.STAFF_ATTENDANCE_LIST.path,
            element: <StaffAttendanceList />
        },
        {
            path: RoutesMap.STAFF_CALENDAR.path,
            element: <StaffAttendanceCalendar />
        },

        {
            path: RoutesMap.PREMISE_USER_ATTENDANCE_LIST.path,
            element: <PremiseUserAttendanceList />
        },
        {
            path: RoutesMap.PREMISE_USER_CALENDAR.path,
            element: <PremiseUserAttendanceCalendar />
        },

        {
            path: RoutesMap.CHANGE_REQUEST_LIST.path,
            element: <ChangeRequestList />
        },

        {
            path: RoutesMap.XPRESS_ADMINS.path,
            element: <XpressAdmins />
        },

        {
            path: RoutesMap.STAFF_MANAGEMENT.path,
            element: <StaffManagement />
        },
        {
            path: RoutesMap.PAYROLL_SUMMARY.path,
            element: <PayrollSummary />
        },
        {
            path: RoutesMap.PAYROLL_SUMMARY_DETAIL.path,
            element: <PayrollSummaryDetail />
        },
        {
            path: RoutesMap.ROLE_AND_USER.path,
            element: <RoleAndUser />
        },
        {
            path: RoutesMap.EXPRESS_ADMIN_ROLES_USERS.path,
            element: <ExpressAdminRolesUsers />
        },
    ]
}

export default UsersRoute;